import { FaYoutube, FaInstagram, FaLinkedin } from "react-icons/fa";
import React, { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// import { Link } from "react-router-dom";
import Logo from "../assets/PNG.png";
const CustomFooter = () => {
  useEffect(() => {
    let map;

    if (!map) {
      map = L.map("map").setView([28.5718487, 77.2219738], 12); 

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      L.marker([28.5718487, 77.2219738]).addTo(map).bindPopup("New Delhi").openPopup();
    }
    return () => {
      if (map) {
        map.remove();
      }
    };
  }, []);
  return (
    <div className="bg-[#001529] h-full relative mt-10 flex flex-col md:flex-row">
      {/* section 1 logo contact link */}
      <div className="flex md:w-1/2 flex-col md:flex-row">
        <div className="md:ml-10 md:w-1/2 flex flex-col items-center md:items-start">
          <img className="w-[150px]" src={Logo} alt="Logo" />
          <h2 className="text-3xl font-bold mb-4 absolute top-[115px] md:absolute md:top-[110px]">
            <span className="text-pink-600">Future</span> Skill
          </h2>
          <div className="text-white text-center md:text-left">
            <h1 className="mb-3">Contact US</h1>
            <p>Mobile: +91 7761876100</p>
          </div>
          <div className="flex mt-2">
            <FaYoutube className="text-red-600" size={40} />
            <FaInstagram className="text-pink-600 mx-2" size={40} />
            {/* <FaLinkedin className="text-blue-600" size={40} /> */}
          </div>
        </div>

        {/* section 2  */}
        <div className="md:ml-10 my-10 flex flex-col items-center md:items-start">
          {/* section 2 Our Courses */}
          <div className="text-white">
            <h1>Our Courses</h1>
            <p className="my-1 mx-5">- Web development</p>
            <p className="my-1 mx-5">- Graphic design</p>
            <p className="my-1 mx-5">- Advanced Excel</p>
            <p className="my-1 mx-5">- Digital Marketing</p>
            <p className="my-1 mx-5">- Tally with GST</p>
            <p className="my-1 mx-5">- DCA/ADCA</p>
            <p className="my-1 mx-5">- English Spoken</p>
          </div>
          {/* section 2 Our Schedule */}
          <div className="text-white my-5">
            <h1>Schedule</h1>
            <p className="my-1 mx-5">Mon - Sat: 8:00 AM - 8:00 PM</p>
            <p className="my-1 mx-5">Sun: Closed</p>
          </div>
        </div>
      </div>

      {/* map location  */}
      <div className="text-white my-10 flex flex-col items-center">
        <h2 className="text-center">Our Location</h2>
        <div
          id="map"
          className="w-full md:w-[600px]"
          style={{ height: "250px", maxWidth: "650px" }}
        ></div>
      </div>
    </div>
  );
};
export default CustomFooter;
